import { createContext, useContext, useState, useCallback } from 'react'

const MobileAuthContext = createContext(null)

export const useMobileAuth = () => {
  const context = useContext(MobileAuthContext)
  if (!context) {
    throw new Error('useMobileAuth must be used within a MobileAuthProvider')
  }
  return context
}

// Session comes from a scanned QR payload: { company_id, username, token }
// `token` is a company-scoped API token (minted in the admin "Tokens de API" screen)
// used as-is as the Bearer token for the read-only dashboard endpoints.
export const MobileAuthProvider = ({ children }) => {
  const [token, setToken] = useState(localStorage.getItem('mobile_access_token'))
  const [companyId, setCompanyId] = useState(localStorage.getItem('mobile_company_id'))
  const [username, setUsername] = useState(localStorage.getItem('mobile_username'))
  const [companyName, setCompanyName] = useState(localStorage.getItem('mobile_company_name'))

  const login = useCallback(({ company_id, username: name, token: apiToken, companyName: company }) => {
    localStorage.setItem('mobile_access_token', apiToken)
    localStorage.setItem('mobile_company_id', company_id)
    localStorage.setItem('mobile_username', name || '')
    localStorage.setItem('mobile_company_name', company || '')
    setToken(apiToken)
    setCompanyId(company_id)
    setUsername(name || '')
    setCompanyName(company || '')
  }, [])

  const logout = useCallback(() => {
    localStorage.removeItem('mobile_access_token')
    localStorage.removeItem('mobile_company_id')
    localStorage.removeItem('mobile_username')
    localStorage.removeItem('mobile_company_name')
    setToken(null)
    setCompanyId(null)
    setUsername(null)
    setCompanyName(null)
  }, [])

  const value = {
    token,
    companyId,
    username,
    companyName,
    isAuthenticated: Boolean(token && companyId),
    login,
    logout,
  }

  return (
    <MobileAuthContext.Provider value={value}>
      {children}
    </MobileAuthContext.Provider>
  )
}
